import { defineComponent as _defineComponent } from 'vue'
import {
  FeatureFlag,
  Trade,
  activeMarginTradeStates,
  closedTradeStatuses,
  formatLiquidityProviders,
} from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { computed } from 'vue';
import FundingTypeCell from '../tableCells/FundingTypeCell.vue';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { useTradeState } from '../..';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';
import { useFeatureFlag } from 'ah-common-stores/src/stores/featureFlagStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeMarginInfo',
  props: {
    trade: null
  },
  setup(__props: any) {

const props = __props as {
  trade: Trade;
};



const tradeState = useTradeState();

const { isActive: isVariationMarginFeatureActive } = useFeatureFlag({
  featureFlag: FeatureFlag.VARIATION_MARGIN_AND_LIMITS_FEATURE,
});

const isClosed = computed(() => {
  return closedTradeStatuses.includes(props.trade.status);
});

const gbpInitialMarginValue = computed(() => {
  return props.trade.gbpInitialMarginAmount ?? 0;
});

const gbpVariationMargin = computed(() => {
  return props.trade.gbpVmm ?? 0;
});

const tradeMarginIsActive = computed(() => {
  return activeMarginTradeStates.includes(props.trade.state);
});

const gbpInUseMarginValue = computed(() => {
  if (!tradeMarginIsActive.value) {
    return 0;
  }
  return gbpVariationMargin.value + gbpInitialMarginValue.value;
});

const isAdminUser = computed(() => tradeState.store.useAuthStore().isAHUser);

const onBehalfOfClient = useOnBehalfOf();

return { __sfc: true,props, tradeState, isVariationMarginFeatureActive, isClosed, gbpInitialMarginValue, gbpVariationMargin, tradeMarginIsActive, gbpInUseMarginValue, isAdminUser, onBehalfOfClient, formatLiquidityProviders, formatCurrencyValue, FundingTypeCell, formatDate }
}

})